<div class="dashboardPage">
  <app-rongo-mauri-chart class="hide-check"></app-rongo-mauri-chart>
  <app-rongo-taonga-abundance-chart class="hide-check"></app-rongo-taonga-abundance-chart>
  <app-widget-maramataka-phase></app-widget-maramataka-phase>
  <app-weather-historical-chart></app-weather-historical-chart>
  <app-weather-forecast-chart></app-weather-forecast-chart>
  <app-rongo-wai-quality-chart class="hide-check"></app-rongo-wai-quality-chart>
  <app-rongo-pest-count-chart class="hide-check"></app-rongo-pest-count-chart>
  <app-rongo-hononga-chart class="hide-check"></app-rongo-hononga-chart>
  <app-rongo-kaupapa-chart class="hide-check"></app-rongo-kaupapa-chart>
  <app-rongo-wai-mauri class="hide-check"></app-rongo-wai-mauri>
  <app-rongo-riparian-features-chart class="hide-check"></app-rongo-riparian-features-chart>
  <app-resolver-custom-widget-layout></app-resolver-custom-widget-layout>
</div>
